module.exports = __webpack_public_path__ + "static/media/polymer-24px.e832bb45.svg";